import React, { useState } from 'react'
import PropTypes from 'prop-types'
import './CustomTooltip.css'
import TooltipElement from './TooltipElement'
const CustomTooltip = props => {
  const rows = props.details
    .sort((e, c) => c.value - e.value)
    .map(el => (
      <div key={el.value + el.name} className={'rowContainer'}>
        <TooltipElement color={el.color} label={el.name} />
        <div className={'toolTipValue'}>
          {el.value} {props.units}
        </div>
      </div>
    ))
  return (
    <div
      className='Rectangle-9'
      style={{ boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.5)' }}
    >
      {rows}
    </div>
  )
}
CustomTooltip.propTypes = {
  details: PropTypes.array.isRequired
}
export default CustomTooltip
